/* istanbul ignore file */
import { EnumField, FieldProps } from 'framework/ui/field';
import { ACCOUNT_TYPES } from '../../model';

const AccountTypeField = (props: FieldProps) => {
  return <EnumField {...props} options={ACCOUNT_TYPES} />;
};

export default AccountTypeField;
